import React from "react";
import Icon from "./Icons";

// TODO: background-colors should be set from config, not hardcoded
const statusColors = {
  default: "#1665D8",
  info: "#1665D8",
  error: "#E6492D",
  success: "#34AA44",
  warning: "#F6AB2F",
};

const getIcon = (variant) => {
  let iconName = "";

  switch (variant) {
    case "success":
      iconName = "Done";
      break;
    case "warning":
      iconName = "Question";
      break;
    default:
      iconName = "ImportantMessage";
  }

  return <Icon name={iconName} />;
};

export const Alerts = ({ alerts = [], removeAlert = () => {} }) =>
  !alerts || (alerts && !Boolean(alerts.length)) ? null : (
    <div className="notifyjs-corner container m:w-page">
      {alerts.map(({ id, message, variant }) => (
        <div
          className="notifyjs-wrapper notifyjs-hidable"
          key={id}
          onClick={() => removeAlert(id)}
          role="alert"
        >
          <div className="notifyjs-arrow" />
          <div className="notifyjs-container">
            <div
              className={`notifyjs-bootstrap-base notifyjs-bootstrap-${variant}`}
            >
              <div className="absolute" style={{ left: 16, top: 15 }}>
                {getIcon(variant)}
              </div>
              <span data-notify-text="">{message}</span>
              <div className="absolute" style={{ right: 16, top: 15 }}>
                <Icon name="CloseButton" />
              </div>
            </div>
          </div>
        </div>
      ))}

      <style jsx="true" global="true">
        {`
          .notifyjs-corner {
            top: 0px;
            right: 0px;
            left: 0px;
          }

          .notifyjs-bootstrap-base {
            font-weight: 600;
            padding: 13px 54px 13px 54px;

            background-color: ${statusColors.default};

            border-radius: 4px;
            text-align: left;

            background-repeat: no-repeat;
            background-position: 16px 15px;

            font-size: 14px;
            line-height: 22px;
            box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
            -webkit-font-smoothing: antialiased;
          }
          .notifyjs-bootstrap-error {
            color: #fff;
            background-color: ${statusColors.error};
          }
          .notifyjs-bootstrap-success {
            color: #fff;
            background-color: ${statusColors.success};
          }
          .notifyjs-bootstrap-info {
            color: #fff;
            background-color: ${statusColors.info};
          }
          .notifyjs-bootstrap-warning {
            color: #fff;
            background-color: ${statusColors.orange};
          }

          .notifyjs-corner {
            position: fixed;
            z-index: 1050;
          }

          .notifyjs-corner .notifyjs-wrapper,
          .notifyjs-corner .notifyjs-container {
            position: relative;
            display: block;
            margin: 7px 0px;
          }

          .notifyjs-wrapper {
            z-index: 1;
            position: absolute;
            display: inline-block;
          }

          .notifyjs-container {
            display: none;
            z-index: 1;
            position: absolute;
          }

          .notifyjs-hidable {
            cursor: pointer;
          }

          [data-notify-text],
          [data-notify-html] {
            position: relative;
          }

          .notifyjs-arrow {
            position: absolute;
            z-index: 2;
            width: 0;
            height: 0;
          }
        `}
      </style>
    </div>
  );
